export const contractAddresses = {
    ethereum: {
        usdc: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    },
    base: {
        usdc: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
        ddp: process.env.REACT_APP_DDP_BASE_CONTRACT_ADDRESS || '0x',
        nrs: process.env.REACT_APP_NRS_BASE_CONTRACT_ADDRESS || '0x',
        // veNrs: process.env.REACT_APP_VE_NRS_BASE_CONTRACT_ADDRESS || '0x',
        // nrsRewardController: process.env.REACT_APP_NRS_REWARD_CONTROLLER_POLYGON_CONTRACT_ADDRESS || '0x',
        // nrsWithdrawalTimelock: process.env.REACT_APP_NRS_WITHDRAWAL_TIMELOCK_POLYGON_CONTRACT_ADDRESS || '0x',
        lockNrs: process.env.REACT_APP_LOCK_NRS_BASE_CONTRACT_ADDRESS || '0x',
        nrsLockWithdrawalTimelock: process.env.REACT_APP_NRS_LOCK_WITHDRAWAL_TIMELOCK_BASE_CONTRACT_ADDRESS || '0x',
        lpNrsUsdcContract: process.env.REACT_APP_LP_NRS_USDC_BASE_CONTRACT_ADDRESS || '0x',
        lpNrsUsdcStakingContract: process.env.REACT_APP_LP_NRS_USDC_STAKING_BASE_CONTRACT_ADDRESS || '0x',
        lpNxusdUsdcContract: process.env.REACT_APP_LP_NXUSD_USDC_BASE_CONTRACT_ADDRESS || '0x',
        lpNxusdUsdcStakingContract: process.env.REACT_APP_LP_NXUSD_USDC_STAKING_BASE_CONTRACT_ADDRESS || '0x',
        lpNxusdUsdcPoolContract: process.env.REACT_APP_LP_NXUSD_USDC_BASE_CONTRACT_ADDRESS || '0x',
        lpNrsUsdcPoolContract: process.env.REACT_APP_LP_NRS_USDC_BASE_CONTRACT_ADDRESS || '0x',
    }
};

export const tokenDecimals = {
    usdc: 6,
    nrs: 18,
    lp: 18,
    veNrs: 18,
    lockNrs: 18
};
